import { render, staticRenderFns } from "./NewAyudaRepReversiones.vue?vue&type=template&id=3d6658b4&scoped=true"
import script from "./NewAyudaRepReversiones.vue?vue&type=script&lang=js"
export * from "./NewAyudaRepReversiones.vue?vue&type=script&lang=js"
import style0 from "./NewAyudaRepReversiones.vue?vue&type=style&index=0&id=3d6658b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6658b4",
  null
  
)

export default component.exports